import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Panel } from '../../../../common/panel'
import { RULES_TYPE } from '../../../common/constant'
import { EVENT_RULES_COL } from '../constant'
import classes from '../index.module.scss'
import { selectDataTable, selectIdsTable } from '../store/slice'
import { Table } from './../../../../common/table'
import { EmailCell } from './EmailCell'
import { EventCell } from './EventCell'
import { SwitchCell } from './SwitchCell'

export const EventRules = ({ isCreate = false }) => {
  const ids = useSelector(selectIdsTable([RULES_TYPE.EVENT_RULES]))
  const data = useSelector(selectDataTable(ids[0]))

  const getSchema = () => {
    return Object.keys(EVENT_RULES_COL).map((key) => {
      const title = `alertSetting.${key}`
      const colId = EVENT_RULES_COL[key]
      const thStyle = {
        justifyContent: [EVENT_RULES_COL.SEND_EMAILS].includes(colId)
          ? 'center'
          : '',
      }
      const tdStyle = {
        width:
          colId === EVENT_RULES_COL.SWITCH
            ? 40
            : colId === EVENT_RULES_COL.SEND_EMAILS
            ? '25%'
            : '',
        position: 'relative',
      }

      return {
        colId,
        title,
        isI18n: true,
        thStyle,
        tdStyle,
        renderTh: (title) => {
          switch (colId) {
            case EVENT_RULES_COL.SWITCH:
              return ''
            default:
              return title
          }
        },
        render: (_, { rowId }) => {
          switch (colId) {
            case EVENT_RULES_COL.SWITCH:
              return <SwitchCell rowId={rowId} isCreate={isCreate} />
            case EVENT_RULES_COL.EVENT:
              return <EventCell rowId={rowId} isCreate={isCreate} />
            case EVENT_RULES_COL.SEND_EMAILS:
              return <EmailCell rowId={rowId} />
            default:
              return ''
          }
        },
      }
    })
  }

  return (
    <Panel label={data?.groupName}>
      <Element style={{ backgroundColor: '#FFFFFF' }}>
        <Element
          className={classes.note}
          style={{ color: '#3A414B', borderBottomColor: '#B5CEF8' }}
        >
          <Translate value="alertSetting.EVENT_RULES_NOTE" />
        </Element>
        <Table ids={ids} schema={getSchema()} autoHeightMax={600} />
      </Element>
    </Panel>
  )
}
